let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("c4Piz")).then(() => parcelRequire('b9JjP'));